import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { TranslateModule } from '@ngx-translate/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './config/routes.config';
import { provideMockServices } from './mock/mock-service.config';
import { authenticationInterceptor } from './interceptor/authentication.interceptor';
import { dateTimeInterceptor } from './interceptor/date-time.interceptor';
import localeDe from '@angular/common/locales/de';
import localeHu from '@angular/common/locales/hu';
import localeEn from '@angular/common/locales/en';
import { registerLocaleData } from '@angular/common';
import { provideLocaleId } from './util/locale/locale-id.provider';

// register locale specific formats like number and date formats
registerLocaleData(localeEn, 'en');
registerLocaleData(localeHu, 'hu');
registerLocaleData(localeDe, 'de');

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        importProvidersFrom(TranslateModule.forRoot()),
        provideHttpClient(withInterceptors([authenticationInterceptor, dateTimeInterceptor])),
        provideMockServices(),
        provideOAuthClient(),
        provideLocaleId(),
    ],
};
